import { useContext } from "react";
import { FileTypes } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";


export default function PostTemplateDrawingLink() {

	const { order } = useContext(RetailOrderContext);
	var postTemplateDrawing = order.details.files.filter(x => x.fileTypeID === FileTypes.PostTemplateDrawing)
		.sort((x, y) => { return y.uploadDate.getTime() - x.uploadDate.getTime() })[0];

	return (<>
		{
			postTemplateDrawing &&
			<div>
				<a href={postTemplateDrawing.publicURL}
					className="document-link"
					target="_blank" download={postTemplateDrawing.fileName}>
					<i className="dx-icon dx-icon-download" />
					View Post Template Drawing
				</a>
			</div>
		}
	</>
	)
} 
